import { BREAKPOINTS } from "@constants";
import { animated } from "@react-spring/web";
import styled from "styled-components";
import { FlexRow } from "../quarks/Flex";

export const ModalLayout = styled(animated.div)`
  --modalPreferredWidth: 600px;
  --modalHeight: 80vh;

  display: grid;
  height: min(var(--modalHeight), calc(100vh - 32px));
  width: clamp(30vw, var(--modalPreferredWidth), calc(100vw - 32px));

  ${BREAKPOINTS.small`
    width: 100vw;
    height: calc(var(--100vh) - 30px);
  `}
`;

export const ModalCenterWrap = styled(FlexRow).attrs(({ ...attrs }) => ({
  alignItems: "center",
  justifyContent: "center",
  sm: {
    alignItems: "flex-end",
  },
  ...attrs,
}))`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: var(--100vh, 100vh);
  display: flex;
  pointer-events: none;
`;
